// This file should not contain any imports of styled-components
import {
  fontSangBleuSunrise,
  fontSangBleuSunriseLivre,
  fontSourceSans3,
} from './fonts'

export const baseFontSize = 16

export const colours = {
  primary: {
    primary: '#8331a7',
    black: '#000000',
    charcoal: '#4f4e4f',
    white: '#ffffff',
  },
  secondary: {
    primary: '#62247d',
    secondary: '#0063a1',
  },
  tertiary: {
    primary: '#ffffff',
  },
  background: {
    main: '#ffffff',
  },
  grey: {
    90: '#3d3d3b', // darkGrey
    75: '#8a8a87', // midGrey
    60: '#ababab', // greyAB
    45: '#eaeae9', // lightGrey
    30: '#f7f7f7', // greyF7
    15: '#fafafa', // lighterGrey
  },
  status: {
    error: '#c90000',
    success: '#00a11f',
    info: '#00b3c9',
    warning: '#F56600',
  },
}

export const fontFamilies: Record<
  'sangbleu' | 'sourceSans' | 'sangbleuLivre',
  string
> = {
  sangbleu: fontSangBleuSunrise.style.fontFamily,
  sourceSans: fontSourceSans3.style.fontFamily,
  sangbleuLivre: fontSangBleuSunriseLivre.style.fontFamily,
} as const

export const fonts = {
  baseSize: baseFontSize,
  headerFont: fontFamilies.sangbleu,
  bodyFont: fontFamilies.sourceSans,
}
